import Cookies from 'js.cookie/dst/Cookie';
import authHeader from "../auth/auth-header";
import redirectToLogin from "../auth/redirect-to-login";
import {saveAs} from 'file-saver';

const axios = require("axios").default;

// Редирект на логин при истечении сессии (401/403) для всех API-запросов через axios
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            redirectToLogin();
        }
        return Promise.reject(error);
    }
);

function ChartAPI() {
    this.axiosRequest = axios;
    this.hostname = window.location.hostname;
    this.protocol = `${process.env.VUE_APP_CLIENT_PROTOCOL}`;
    this.domen = `${process.env.VUE_APP_CLIENT_API_DOMEN}`;
    this.client = `${process.env.VUE_APP_CLIENT_URI}`;
    this.clientDynamic = `${process.env.VUE_APP_CLIENT_DYNAMIC_URI}`;
    this.clientOrganic = `${process.env.VUE_APP_CLIENT_ORGANIC_URI}`;
    this.stats = `${process.env.VUE_APP_STATS_URI}`;
    this.parseCount = `${process.env.VUE_APP_PARSE_COUNT}`;
    this.keywords = `${process.env.VUE_APP_KEYWORDS}`;
    this.keywordsStats = `${process.env.VUE_APP_KEYWORDS_STATS_URI}`;
    this.keywordsTypes = `${process.env.VUE_APP_KEYWORDS_TYPES_URI}`;
    this.projects = `${process.env.VUE_APP_CLIENTS_URI}`;
    this.competitors = `${process.env.VUE_APP_ADVERTISERS_URI}`;
    this.usp = `${process.env.VUE_APP_USP_URI}`;
    this.wordstat = `${process.env.VUE_APP_WORDSTAT}`;
    this.logo = `${process.env.VUE_APP_LOGO}`;
    this.geolocation_tags = `${process.env.VUE_APP_GEOLOCATION_TAGS}`;
    this.organicKeywords = `${process.env.VUE_APP_KEYWORDS_STATS_ORGANIC}`;
    this.advertisers = `${process.env.VUE_APP_ADVERTISERS}`;
    this.adQuality = "ad_quality/project";

    this.requestingTypeURL = {
        "getPivotChart": this.client, "getKeywords": this.keywords,
        "getProjects": this.projects, "getKeywordsStats": this.keywordsStats, "getKeywordsTypes": this.keywordsTypes,
        "getUsp": this.usp, "getCompetitors": this.competitors, "getWordstat": this.wordstat,
        "getLogo": this.logo, "getGeolocationTags": this.geolocation_tags, "getDynamicSOV": this.clientDynamic,
        "getOrganicPivotChart": this.clientOrganic, "getOrganicKeywords": this.organicKeywords,
        "getAdvertisers": this.advertisers, "getAdQuality": this.adQuality
    }


}

function downloadFile(data, filename) {
    const blob = new Blob([data]);
    // if (typeof window.navigator.msSaveBlob !== 'undefined') {
    //   window.navigator.msSaveBlob(blob, filename);
    //   return;
    // }
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    setTimeout(() => {
      // Delay for Firefox
      window.URL.revokeObjectURL(blobURL);
    }, 120);
  }


ChartAPI.prototype.sendRequest = async function (
    requestType = "common",
    clientID = null,
    prefix = null,
    queryParams = {}
) {
    let ourURL = `${this.protocol}://${window.location.hostname}${this.domen}/${this.requestingTypeURL[requestType]}`;
    if (clientID) {
        ourURL = ourURL + "/" + clientID;
    }
    if (prefix) {
        ourURL += prefix;
    }

    return await this.axiosRequest
        .get(ourURL, {
            headers: {
                Authorization: authHeader(),
            },
            mode: "no-cors",
            credentials: "include",
            params: queryParams,
        })
        .catch((err) => {
            // pass
        })
        .then((response) => {
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                return response.data;
            }
            // Ответ не JSON (например, HTML страницы входа после редиректа) — сессия недействительна
            redirectToLogin();
            return [];
        })
        .catch((err) => {
            // pass
        })
        .then((data) => {
            return data;
        })
        .catch((err) => {
            if (requestType === "getPivotChart") {
                if (err.response.status === 400) {
                    if (err.response.data['detail'] === "Advertiser on this client not exist") {
                        return {error: "Отсутствует рекламодатель"}
                    } else {
                        return {error: "Ошибка"}
                    }
                } else if (err.response.status === 404) {
                    return {error: "Запрашиваемый клиент не найдет"}
                }
                return {
                    error: err.response.status
                }
            } else if (requestType === "getLogo") {
                if (err.response.status === 400) {
                    return "No Logo found";
                }
            } else if (requestType === "getUsp") {
                if (err.response.status === 400) {
                    return [];  // USP empty list will appear if 400 error exists
                }
            } else if (requestType === "getOrganicPivotChart") {
                if (err.response.status === 400) {
                    return [];  // USP empty list will appear if 400 error exists
                }
            } else {
                //pass;
            }
        });
    }

ChartAPI.prototype.getStatsClientReport = async function (prefix, clientID) {
  let ourURL = `${this.protocol}://${window.location.hostname}${this.domen}/${this.client}`;
  if (prefix) {
    ourURL = ourURL + "/" + clientID + prefix + "&top=0" + "&format=csv";
  } else {
    ourURL = ourURL + "/" + clientID + "?top=0" + "&format=csv";
  }
  return this.axiosRequest
    .get(ourURL, {
      headers: {
        Authorization: authHeader(),
      },
      mode: "no-cors",
      credentials: "include",
    })
    .then((response) => response.data)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      // Ошибка получения статистики клиента
    });
};

ChartAPI.prototype.getDownloadReport = async function (downloadReportType, urls, clientID=null) {
    let ourURL = `${this.protocol}://${window.location.hostname}${this.domen}/${downloadReportType}/`;
    let final_urls = urls;
    if (clientID) {
        final_urls = urls.map(url => `${clientID}${url}`);
    }

    return this.axiosRequest
    .post(ourURL, {
      data: final_urls
    },{
      headers: {
        Authorization: authHeader(),
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      mode: downloadReportType === "export-usp" ? "cors" : "no-cors",
      credentials: "include",
      responseType: 'blob',
    })
    .then((response) => {
        let currentDateTime = new Date();
        let currentDateTimeTitle = currentDateTime.getDate() + "-" + currentDateTime.getMonth() + "-" + currentDateTime.getFullYear() + "-" + currentDateTime.getHours() + "-"
            + currentDateTime.getMinutes() + "-" + currentDateTime.getSeconds();
        if (downloadReportType === "export-sov") {
            // downloadFile(response.data, `sov-${currentDateTimeTitle}.xlsx`)
            saveAs(new Blob([response.data]), `sov-${currentDateTimeTitle}.xlsx`)
        }
        else if (downloadReportType === "export-keywords-dynamic") {
            // downloadFile(response.data, `keywords-${currentDateTimeTitle}.xlsx`)
            saveAs(new Blob([response.data]), `keywords-${currentDateTimeTitle}.xlsx`)
        } else if (downloadReportType === "export-organic-dashboard") {
            // downloadFile(response.data, `organic-${currentDateTimeTitle}.xlsx`)
            saveAs(new Blob([response.data]), `organic-${currentDateTimeTitle}.xlsx`)
        } else if (downloadReportType === "export-keywords-organic") {
            // downloadFile(response.data, `keywords-organic-${currentDateTimeTitle}.xlsx`)
            saveAs(new Blob([response.data]), `keywords-organic-${currentDateTimeTitle}.xlsx`)
        }
        else if (downloadReportType === "export-dynamic-dashboard") {
            // downloadFile(response.data, `dynamic-${currentDateTimeTitle}.xlsx`)
            saveAs(new Blob([response.data]), `dynamic-${currentDateTimeTitle}.xlsx`)
        } else if (downloadReportType === "export-ad-quality") {
            saveAs(new Blob([response.data]), `ad_quality_report_${currentDateTime.getDate()}-${currentDateTime.getMonth() + 1}-${currentDateTime.getFullYear()}.xlsx`)
        }
        else if (downloadReportType === "export-usp") {
            // Используем имя файла из заголовка Content-Disposition или fallback
            const contentDisposition = response.headers['content-disposition'];
            let filename = `usp-${currentDateTimeTitle}.xlsx`; // fallback
            
            if (contentDisposition) {
                // Пробуем сначала filename*=UTF-8'' (RFC 5987)
                let filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1]);
                } else {
                    // Fallback на обычный filename
                    filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }
            }
            
            saveAs(new Blob([response.data]), filename)
        }
        else {
            downloadFile(response.data, `wordstat-${currentDateTimeTitle}.xlsx`)
            // saveAs(new Blob([response.data], {type: mime || 'application/octet-stream'}), `wordstat-${currentDateTimeTitle}.xlsx`)
        }
    })
    .then((data) => {
          return data;
    })
    .catch((err) => {
      // Ошибка загрузки отчета
    });
}

ChartAPI.prototype.getCompetitors = async function (clientID) {
    return await this.sendRequest("getCompetitors", clientID)
};

/**
 * GET-экспорт отчёта по ссылкам/доменам рекламодателя (advertiser_id 27274 или 27984).
 * @param {number} projectId
 * @param {number} advertiserId
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @returns {Promise<void>}
 */
ChartAPI.prototype.getAdvertiserUrlsReport = async function (projectId, advertiserId, startDate, endDate) {
    const baseURL = `${this.protocol}://${window.location.hostname}${this.domen}/export-advertiser-urls/`;
    const params = new URLSearchParams({
        project_id: projectId,
        advertiser_id: advertiserId,
        start_date: startDate,
        end_date: endDate,
    });
    const url = `${baseURL}?${params.toString()}`;
    return this.axiosRequest.get(url, {
        headers: { Authorization: authHeader() },
        credentials: "include",
        responseType: "blob",
    }).then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        let filename = `advertiser_urls_${advertiserId}.xlsx`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
            if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1]);
            } else {
                const m = contentDisposition.match(/filename=["']?([^"';]+)["']?/);
                if (m && m[1]) filename = m[1].trim();
            }
        }
        saveAs(new Blob([response.data]), filename);
    });
};

export default ChartAPI;
